<template>
  <div>
    <div
      v-if="showHeaderBigWorldview"
      class="flex justify-center items-center relative flex-col bg-black/80 pt-4 pb-2"
    >
      <DriftCapsuleDot class="absolute" :things="['twinkling-star']" />
      <img
        @click="clickToWorldviewEdit(activeWorldview!)"
        :src="activeWorldview?.media?.url || useDefaultWorldviewImg()"
        alt="my-universe"
        class="w-[80%] relative z-10"
      />
      <p class="text-base mt-2 text-center text-white/80 font-[Cubic]">
        {{ useName(activeWorldview?.name) }}
      </p>
    </div>

    <!-- 星球水平列表展示 -->
    <div class="flex gap-2 pl-4 my-2 relative">
      <div
        class="flex flex-1 gap-2"
        :class="{
          'overflow-x-auto': !disableXScroll,
        }"
      >
        <!-- <div
          v-if="isMy"
          class="rounded-md flex flex-col items-center justify-center flex-shrink-0 gap-1"
          @click="clickWorldview()"
        >
          <img
            src="/img/my-universe.gif"
            alt="my-universe"
            :class="
              activeWorldview
                ? 'w-10 h-10 grayscale'
                : 'w-[50px] h-[50px] grayscale-0'
            "
          />
          <p class="text-xs">{{ $t("User.home.universe") }}</p>
        </div> -->
        <div
          v-for="worldview in list"
          :key="worldview.id"
          :class="[
            'rounded-md flex flex-col gap-1 items-center justify-center relative flex-shrink-0',
            activeWorldview?.id === worldview.id ? 'w-[50px]' : ' w-[40px]',
          ]"
          @click="clickWorldview(worldview)"
        >
          <img
            :src="worldview.media?.url || useDefaultWorldviewImg()"
            alt="worldview"
            crossorigin="anonymous"
            :class="
              activeWorldview?.id === worldview.id
                ? 'grayscale-0 play-animation'
                : 'grayscale stop-animation'
            "
          />
          <!-- <p class="text-xs line-clamp-1">
            {{ useName(worldview.name) }}
          </p> -->
        </div>
      </div>

      <div
        class="rounded-md flex flex-col gap-1 items-center justify-center relative cursor-pointer"
        @click="clickCreateWorldview"
        v-if="isMy"
      >
        <button class="text-xs whitespace-nowrap btn btn-xs btn-primary mr-2">
          +{{ $t("Dungeons.createPlanet") }}
        </button>
      </div>
      <div
        v-if="disableXScroll"
        class="absolute right-0 inset-y-0 bg-base-100 flex items-center justify-center px-2 cursor-pointer"
        style="
          background: linear-gradient(
            to right,
            hsl(var(--b1) / 0.2) 0%,
            hsl(var(--b1) / 0.9) 10%,
            hsl(var(--b1) / 1) 100%
          );
        "
        @click="emit('viewMore')"
      >
        {{ $t("Buttons.viewMore") }}
      </div>
    </div>

    <!-- 星球详情数据 -->
    <div
      class="grid grid-cols-2 pl-4 bg-base-200 py-2 mt-2 text-base-content/60 text-xs relative"
    >
      <div
        class="absolute top-1 right-1 btn btn-xs btn-outline mr-1"
        v-if="activeWorldview && isMy"
        @click="clickToWorldviewEdit(activeWorldview)"
      >
        <!-- <i class="iconify mingcute--edit-2-line w-4 h-4"></i> -->
        {{ $t(`Buttons.edit`) }}
      </div>
      <div class="line-clamp-1 mb-1 font-bold col-span-2">
        {{ $t("Home.OC.runtime", { runtime }) }}
      </div>
      <div class="text-xs">
        {{
          $t("Home.OC.residentCount", {
            count: isMy
              ? activeWorldviewMates.length
              : activeWorldview?.statsData.mateCount,
          })
        }}
      </div>

      <div v-for="stat in statsType" :key="stat">
        {{
          $t(`Home.OC.${stat}`, {
            [`${stat}`]: activeWorldview
              ? activeWorldview.statsData[stat]
              : worldviewStore.worldviewList.reduce(
                  (acc, v) => acc + v.statsData[stat],
                  0
                ),
          })
        }}
      </div>
    </div>

    <!-- 星球OC伙伴列表 -->
    <div class="pl-5 my-3 relative">
      <div
        class="text-base lg:text-xl font-semibold red-dot mb-2 flex justify-between gap-2 items-center"
      >
        <div class="flex-1">
          {{
            $t("Home.OC.OCResident", {
              name: activeWorldview
                ? useName(activeWorldview.name)
                : $t(`User.home.universe`),
            })
          }}
        </div>
        <div v-if="isMy">
          <button
            v-if="activeWorldviewMates.some((mate) => mate.isPreset)"
            class="btn btn-xs"
            @click="clickRemoveAllPreset"
          >
            {{ $t("User.mate.removeAllPreset") }}
          </button>
          <button
            class="btn btn-xs btn-primary mr-2"
            @click="mateStore.clickCreateMateOption()"
          >
            {{ $t("Home.OC.addMate") }}
          </button>
        </div>
      </div>

      <div
        class="flex gap-4 items-center"
        :class="{ 'overflow-x-auto': !disableXScroll }"
      >
        <div
          v-if="activeWorldviewMates.length === 0"
          class="flex-1 flex justify-center items-center"
        >
          <VanEmpty image-size="100" :description="$t('Home.OC.noMates')" />
        </div>
        <div
          v-else
          v-for="mate in activeWorldviewMates"
          :key="mate.id"
          class="flex flex-col gap-2 w-12 flex-shrink-0 items-center relative"
          @click="
            onMateItemClicked(mate, {
              name: 'mateHome',
              params: {
                uuid: mate.uuid,
              },
            })
          "
        >
          <div
            v-if="mate.isPreset"
            class="absolute top-0 right-0 badge badge-neutral z-[1] badge-xs text-[10px]"
          >
            {{ $t(`User.mate.preset`) }}
          </div>

          <div
            v-else-if="mate.status === 0"
            class="absolute top-0 right-0 badge badge-neutral z-[1] badge-xs text-[10px]"
          >
            {{ $t(`User.mate.draft`) }}
          </div>
          <UserAvatar :mate="mate" class="w-full" />
          <p class="text-xs line-clamp-1">
            {{ useName(mate.name) }}
          </p>
        </div>
      </div>
      <div
        v-if="disableXScroll"
        class="absolute right-0 inset-y-0 bg-base-100 flex items-center justify-center px-2 pl-4 cursor-pointer"
        style="
          background: linear-gradient(
            to right,
            hsl(var(--b1) / 0.2) 0%,
            hsl(var(--b1) / 0.8) 10%,
            hsl(var(--b1) / 1) 100%
          );
        "
        @click="emit('viewMore')"
      >
        {{ $t("Buttons.viewMore") }}
      </div>
    </div>

    <!-- 星球编年史 -->
    <div class="pl-5 my-3">
      <div class="text-base lg:text-xl font-semibold red-dot mb-2">
        {{
          $t("Home.planet.timeline", {
            name: activeWorldview
              ? useName(activeWorldview.name)
              : $t(`User.home.universe`),
          })
        }}
      </div>

      <div class="">
        <TimelineModule
          v-if="initFinished"
          :enable-edit="false"
          :entity-id="activeWorldview?.id || 0"
          entity-type="worldview"
          :entity-uuid="activeWorldview?.uuid || ''"
          :universe-id="
            activeWorldview?.universeId ||
            useGlobalUser().user.defaultUniverseId
          "
          :disable-x-scroll="disableXScroll"
        />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { RouteLocationRaw, useRoute, useRouter } from "vue-router";

import { useGlobalUser } from "@/stores/globalUser";
import { useMate } from "@/stores/mate";
import { useWorldview } from "@/stores/worldview";
import { Mate, Worldview } from "@/types/entity";
import { useDefaultWorldviewImg, useName } from "@/use/common";
import moment from "moment-timezone";
import { showConfirmDialog, showLoadingToast } from "vant";
import { computed, onActivated, onMounted, onUnmounted, ref } from "vue";
import { useI18n } from "vue-i18n";
import DriftCapsuleDot from "@/views/Mate/DriftCapsule/DriftCapsuleDot.vue";
const { t } = useI18n();
const mateStore = useMate();
const router = useRouter();
const route = useRoute();
const worldviewStore = useWorldview();
const activeWorldview = ref<Worldview>();

const statsType = computed<Array<keyof Worldview["statsData"]>>(() =>
  activeWorldview.value
    ? ["wordCount", "mediaCount", "momentCount"]
    : ["wordCount", "mediaCount", "momentCount", "storyCount"]
);

const props = withDefaults(
  defineProps<{
    mode?: "my" | "explore";
    worldviewList?: Worldview[];
    disableXScroll?: boolean;
    showHeaderBigWorldview?: boolean;
  }>(),
  {
    mode: "my",
    worldviewList: () => [],
    disableXScroll: false,
    showHeaderBigWorldview: false,
  }
);

const emit = defineEmits<{
  (e: "viewMore"): void;
}>();

const list = computed(() => {
  if (props.mode === "my") return worldviewStore.worldviewList;
  return props.worldviewList;
});

const isMy = computed(() => props.mode === "my");

const activeWorldviewMates = computed(() => {
  if (isMy.value) {
    return activeWorldview.value
      ? mateStore.list.filter(
          (mate) => mate.currentWorldviewId === activeWorldview.value!.id
        )
      : mateStore.list;
  } else {
    return activeWorldview.value?.matezz || [];
  }
});

const runtime = ref("");
const updateRuntime = () => {
  let dtCreate = activeWorldview.value
    ? activeWorldview.value!.dtCreate
    : mateStore.userMate?.dtCreate;
  if (!dtCreate) return;
  const now = moment();
  const create = moment(dtCreate);
  const allSeconds = now.diff(create, "seconds");
  const days = String(Math.floor(allSeconds / 86400)).padStart(2, "0");
  const hours = String(Math.floor((allSeconds % 86400) / 3600)).padStart(
    2,
    "0"
  );
  const minutes = String(Math.floor((allSeconds % 3600) / 60)).padStart(2, "0");
  const seconds = String(allSeconds % 60).padStart(2, "0");
  let result = "";
  result += `${days}${t("Time.day")}`;
  result += `${hours}${t("Time.hour")}`;
  result += `${minutes}${t("Time.minute")}`;
  result += `${seconds}${t("Time.second")}`;
  runtime.value = result;
};

const onMateItemClicked = async (mate: Mate, to: RouteLocationRaw) => {
  if (mateStore.currentMate?.id !== mate.id)
    await mateStore.changeCurrentMate(mate.id);
  // 2. 当前路由允许Mate切换：直接切换
  router.push(to);
};
const clickCreateWorldview = async () => {
  const toast = showLoadingToast({
    message: t("Message.creating"),
    duration: 0,
  });
  try {
    const worldview = await worldviewStore.createWorldview("");
    toast.close();
    router.push({ name: "worldviewEdit", params: { uuid: worldview.uuid } });
  } catch (e) {
    toast.close();
  }
};
const clickWorldview = async (worldview?: Worldview) => {
  activeWorldview.value = worldview;
  updateRuntime();
};

const clickToWorldviewEdit = async (worldview: Worldview) => {
  router.push({ name: "worldviewEdit", params: { uuid: worldview.uuid } });
};

const clickRemoveAllPreset = async () => {
  try {
    await showConfirmDialog({
      message: t("ConfirmModal.confirmToRemoveAllPreset"),
      confirmButtonText: t("Buttons.confirm"),
      cancelButtonText: t("Buttons.cancel"),
    });
  } catch (e) {
    return;
  }

  const loading = showLoadingToast(t(`Message.loading`));
  try {
    await Promise.all(
      activeWorldviewMates.value
        .filter((mate) => mate.isPreset)
        .map((mate) => {
          return mateStore.deleteCurrentMate(mate);
        })
    );
    loading.close();
  } catch (e) {
    loading.close();
  }
};

let timer: NodeJS.Timeout;
const initFinished = ref(false);
const initPage = () => {
  initFinished.value = false;
  if (isMy.value) {
    worldviewStore.getWorldviewList(true);

    if (route.query.worldviewId) {
      if (Number(route.query.worldviewId) === 0) {
        activeWorldview.value = undefined;
      } else {
        const worldview = worldviewStore.worldviewList.find(
          (worldview) => worldview.id === Number(route.query.worldviewId)
        );
        if (worldview) {
          activeWorldview.value = worldview;
        }
      }
    }
    if (!activeWorldview.value)
      activeWorldview.value = worldviewStore.worldviewList[0];
  } else if (!activeWorldview.value) {
    activeWorldview.value = props.worldviewList[0];
  }

  updateRuntime();
  clearInterval(timer);
  timer = setInterval(() => {
    updateRuntime();
  }, 1000);
  initFinished.value = true;
};

onActivated(() => {
  initPage();
});

onMounted(() => {
  initPage();
});

onUnmounted(() => {
  clearInterval(timer);
});
</script>
